export default function PHP_trait() {
  return (
    <div>
      <h1>PHP_trait</h1>
    </div>
  );
}
